var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "product-page-shell" },
    [
      _c("store-index", {
        attrs: {
          "biz-type": 1,
          "create-or-edit-url": "/product/list/creatProduct",
          "detail-url": "/product/list/productDetail",
          "inventory-adjust-url": "/product/list/inventoryAdjust",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }